<template>
  <div class="layout-topbar" :style="barColor">
    <Button title="Меню" icon="pi pi-bars" class="m-2" :style="barColor" @click="onMenuToggle()"
      data-testid="menu_command" v-show="config['appMenuComponent']" />
    <Button v-show="!store.getters.editMode && route.name === 'form'" title="Скрыть меню объектов"
      icon="pi pi-arrow-right-arrow-left" class="m-1" :style="barColor" @click="setShowFacilityMenu()" />
    <img alt="logo" class="ml-4" src="assets/layout/images/logo_kron_tm128.png" width="52" to="/" />
    <div class="ml-4 layout-topbar-text font-bold">
      {{ store.getters.const('PROGARM_NAME_RU') }}
      {{ serverNameRu }}
    </div>
    <div class="topbar-menu" style="align-items: center; justify-content: center">
      <Button @click="toggleUserOverlay" data-testid="menu_login" class="p-button-text" style="color:var(--text-color)">
        <i class="pi pi-user mr-1" />
        <div class="flex align-center font-bold">
          <span>{{ store.getters.user?.user_struct_name ?? store.getters.info.login }}</span>
        </div>
      </Button>
      <OverlayPanel ref="op" class="user-menu-panel">
        <div class="user-menu-content">
          <div class="user-info text-center mb-3">
            <h4 class="username mb-2">{{ store.getters.info.login }}</h4>
            <Tag :value="store.getters.info.userRoleName" class="user-role-tag mr-1" severity="info" />
            <Tag :value="serverName" class="user-role-tag" severity="success" />
          </div>
          <div class="mt-2">
            <div>
              <Button style="width: 100%;" label="Сменить пароль" icon="pi pi-key" @click="passwordChange()"
                class="p-button-danger mb-2" />
            </div>
            <div>
              <Button style="width: 100%;" label="Выход" icon="pi pi-sign-out" @click="logout()"
                class="p-button-warning" />
            </div>
          </div>
        </div>
      </OverlayPanel>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import EventBus from '../EventBus';

const props = defineProps({
  newTopbarColor: {
    default: null,
  }
});

const emit = defineEmits(['menu-toggle', 'report-menu-toggle']);

const store = useStore();
const route = useRoute();
const router = useRouter();

const config = computed(() => store.getters.config('layouts'));
const serverNameRu = computed(() => store.getters.const(process.env.VUE_APP_SERVER_NAME));
const serverName = process.env.VUE_APP_SERVER_NAME;

const barColor = computed(() => {
  if (props.newTopbarColor) return { 'background-color': '#' + props.newTopbarColor };
  if (localStorage.topbarColor) return { 'background-color': '#' + localStorage.topbarColor };
  return { 'background-color': '#84abd6' };
});

const op = ref(null);

function onMenuToggle() {
  emit('menu-toggle');
}

function toggleUserOverlay(event) {
  op.value.toggle(event);
}

function setShowFacilityMenu() {
  store.dispatch('setShowFacilityMenu');
  EventBus.emit('on-event-hundler-container');
}

function onReportMenuToggle() {
  emit('report-menu-toggle');
}

function logout() {
  store.dispatch('logout');
  router.push({ path: '/login' });
}

function passwordChange() {
  router.push({ path: '/change-password?type=user' });
}
</script>

<style lang="scss" scoped>
.layout-topbar-text {
  font-size: 2rem;
}

.user-menu-panel {
  min-width: 250px;
}

.user-menu-content {
  padding: 0.5rem;
}

.user-info {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.username {
  color: var(--text-color);
  margin: 0;
  font-weight: 600;
}

.user-role-tag {
  font-size: 0.8rem;
}

:deep(.p-overlaypanel) {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

:deep(.p-button) {
  transition: all 0.3s ease;
}

:deep(.p-button:hover) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 960px) {
  .layout-topbar-text {
    font-size: 1.7rem;
  }
}

@media screen and (max-width: 640px) {
  .layout-topbar-text {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 400px) {
  .layout-topbar-text {
    font-size: 1rem;
  }
}
</style>